import { SET_LOADING, SET_ERROR, SET_SUCCESS } from '../mutationTypes';

const moduleLoading = {
  namespaced: true,

  state: {
    appLoading: false,
    appError: false,
    appSuccess: false,
    staticContentLoading: false,
    staticContentError: false,
    staticContentSuccess: false,
  },

  getters: {

  },

  actions: {
    startLoading({ commit }, type) {
      commit(SET_LOADING, { type: `${type}Loading`, value: true });
    },
    stopLoading({ commit }, type) {
      commit(SET_LOADING, { type: `${type}Loading`, value: false });
    },
    setError({ commit }, type) {
      commit(SET_ERROR, { type: `${type}Error`, value: true });
    },
    removeError({ commit }, type) {
      commit(SET_ERROR, { type: `${type}Error`, value: false });
    },
    setSuccess({ commit }, type) {
      commit(SET_SUCCESS, { type: `${type}Success`, value: true });
    },
    removeSuccess({ commit }, type) {
      commit(SET_SUCCESS, { type: `${type}Success`, value: false });
    },
  },

  mutations: {
    [SET_LOADING](state, payload) {
      state[payload.type] = payload.value;
    },
    [SET_ERROR](state, payload) {
      state[payload.type] = payload.value;
    },
    [SET_SUCCESS](state, payload) {
      state[payload.type] = payload.value;
    },
  },
};

export default moduleLoading;
